export default __webpack_public_path__ + "static/media/discount-badge.5d802b09.svg";